module.exports = __webpack_public_path__ + "media/images/favicons/76x76-ebdf6b8b5381c28d4673acf0525cd61b.png";